import React from 'react';

import Menu from './Menu';

const Sidebar = () => {
  return <Menu />;
};

export default Sidebar;
